import React from 'react'
import classes from 'classnames'
import Loader from './Loader'

const themes = {
  orange: "Button_orange",
  w100: "Button_w100",
  "black-white": "Button_black-white"
}

export default ({ onClick, loading = false, children, theme, ...props }) => {

  const rootClasses = ["Button Button_black"]
  theme && theme.split(" ").forEach(el => rootClasses.push(themes[el]))

  return (
    <button className={classes(rootClasses.join(" "), { 'Button_loading': loading })} onClick={onClick} {...props}>
      {children}
      {loading && (
        <div className='Button__loader'>
          <Loader />
        </div>
      )}
    </button>
  )
}



// WEBPACK FOOTER //
// ./src/components/Button.jsx